import { DatePicker as ADatePicker } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { tableStateSelector } from '../../redux/selectors/tables';
import { appendFilter } from '../../redux/actions/tables';
import { IDatePickerLayout } from '../../types/layouts/date-picker';

const defaultFormat = 'DD.MM.YYYY';
const apiFormat = 'YYYY-MM-DD';

const DatePicker = (props: IDatePickerLayout['config']) => {
    const { action, format: propFormat } = props;
    const dispatch = useDispatch();
    const tableState = useSelector(tableStateSelector(action?.actionTarget.name));
    const format = typeof propFormat === 'string' ? propFormat : defaultFormat;

    const getValue = (): any => {
        if (action?.actionTarget.type === 'list' && tableState instanceof Object) {
            return tableState.filters?.find((el) => el.column === action.actionTarget.column)?.values.map((value: any) => moment(value, apiFormat))?.[0];
        }
        return undefined;
    };

    const onChange = (date: any) => {
        if (action?.actionTarget.type === 'list') {
            dispatch(appendFilter(action?.actionTarget.name, {
                column: action.actionTarget.column,
                values: [date.format(apiFormat)],
            }));
        }
    };

    return React.createElement(ADatePicker, {
        ...props,
        format: format || defaultFormat,
        onChange,
        value: getValue(),
    });
};

export default DatePicker;
